var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('app-bar',{attrs:{"title":"TODO APP","left":"bars","right":"search"}}),_c('avatar'),_c('gradient'),_c('todo-list'),_c('todo-detail'),_c('todo-editing'),_c('floating-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }